/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoices_TabInputs */



/**
* | output |
* | --- |
* | "Invoices" |
*
* @param {Invoices_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const invoices_tab = /** @type {((inputs?: Invoices_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoices_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Factures")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rechnungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fatture")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Счета-фактуры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Facturas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发票")
	if (locale === "ja") return /** @type {LocalizedString} */ ("請求書")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चालान")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Faturas")
	return /** @type {LocalizedString} */ ("Invoices")
});